/**
 * The model, and the harness it runs through (spec 222, spec 240): an organization
 * can have several harnesses, and two profiles on one model may reach it through
 * different ones. Drawn by a profile card's header and by a By workflow profile line.
 */
export function ModelLine({
  model,
  harnessName,
}: {
  model: string;
  harnessName?: string;
}) {
  return (
    <p className="flex flex-wrap items-baseline gap-x-1.5 text-sm break-words">
      <span className="font-medium">{model}</span>
      {harnessName && (
        <span className="text-muted-foreground text-xs">{`via ${harnessName}`}</span>
      )}
    </p>
  );
}
